import App from "./App.svelte";
import "/fonts/fonts.css";
import { getGit, getVersion } from "Utils/gitVersion.js";
import { setHost } from "Utils/settings.js";



let app;
setHost();

const createApp = () => {
  let canvas = window.document.getElementsByTagName("canvas")[0];



  if (canvas) {
    //bloging loading when replays exist
    // TODO: remove after merging the branch with replays

    if (
      window.__REPLAYS__?.isReplayMode() ||
      window.__OPTIONS__?.replay?.length
    ) {
      return;
    }

    app = new App({
      target: document.body,
      //target: target,
    });
  } else {
    setTimeout(() => createApp(), 1000);
  }
};

createApp();



// const version = getVersion();
// console.log(
//   `%cLoyalty  > App Version: ${version}`,
//   "border: 1px solid #E22134; padding: 4px 8px; font-weight: 600"
// );

const git = getGit();
console.log(
  `%cLighCoin > Git Branch/Git Commit: ${git}`,
  "border: 1px solid #E22134; padding: 4px 8px; font-weight: 600"
);

console.log(
  `%cLighCoin > Build mode: ${process.env.NODE_ENV}`,
  "border: 1px solid #E22134; padding: 4px 8px; font-weight: 600"
);

export default app;
